module.exports = __webpack_public_path__ + "img/20191009160424360截图20191009145041420.bff3f837.jpg";